export class InogeniCam300 {
    constructor(socket) {
        this.socket = socket;
        this.firmwareVersion = '1.00';
        this.videoMatrixRoutes = '1';
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /[<$]GET[>$]/i,
                callback: (match) => {
                    this.socket.send(`Version ${this.firmwareVersion}`);
                },
            },
            {
                name: 'videoSwitchQuery',
                regExp: /[<$]POLL[>$]/i,
                callback: (match) => {
                    this.socket.send(`${this.videoMatrixRoutes}`);
                },
            },
            {
                name: 'videoSwitchSet',
                regExp: /[<$]IN(\d)[>$]/i,
                callback: (match) => {
                    this.videoMatrixRoutes = match[1];
                    this.socket.send(`${this.videoMatrixRoutes}`);
                },
            },
        ];
    }
}
InogeniCam300.emulatorType = 'socketEmulator';
InogeniCam300.key = '-NT9CdTCBDIGVjZ408Jb';
